export default {"src":"/_next/static/media/menu.1a25c33a.svg","height":19,"width":27,"blurWidth":0,"blurHeight":0};